import $ from 'jquery'

$('[data-toggle="tooltip"]').tooltip()
